// src/scene/config/SkyConfig.ts
// Sky visual configuration (wind lines) - generated by IslandDebug.
// Paste this entire file to replace src/scene/config/SkyConfig.ts

// Wind Lines: Spawning
export const maxLines  = 5;
export const spawnRate = 3.3000; // lines spawned per second at full breeze intensity
export const rampUp    = 2.1000; // seconds to reach full intensity (breeze start)
export const rampDown  = 5.3000; // seconds to fade out (breeze end)

// Wind Lines: Line shape
export const minLength = 251;    // px
export const maxLength = 485;    // px
export const tiltY     = 0.0400; // downward drift, px per px traveled left (0 = horizontal)

// Wind Lines: Vertical spread
export const minWorldY = 0.7500; // lowest spawn Y in Three.js world units
export const maxWorldY = 3.5500; // highest spawn Y in Three.js world units

// Wind Lines: Width
export const minWidth = 1.6000; // px
export const maxWidth = 3.0000; // px

// Wind Lines: Speed
export const minSpeed = 200; // px/s
export const maxSpeed = 315; // px/s

// Wind Lines: Appearance
export const lineOpacity = 0.3100; // peak opacity per line (0-1)
export const colorR      = 232;    // RGB 0-255
export const colorG      = 228;
export const colorB      = 228;

// Wind Lines: Wave / wobble
export const waveAmplitude = 6.5000; // max vertical displacement (px); 0 = straight lines
export const waveFrequency = 1.4000; // full sine cycles per line (1 = one wave, 2 = two waves)
export const waveSpeed     = 4.3000; // animation speed, radians per second phase shift
export const waveSegments  = 16;     // sub-divisions per line (higher = smoother, min 4)

// Wind Lines: 3D World-Space Depth
export const minZOffset = -2.8000; // Z offset relative to island Z (negative = further from camera)
export const maxZOffset =  0.5000; // Z offset relative to island Z (positive = closer to camera)

// Wind Lines: Island Proximity Fade
export const islandDisappearDist = 4.4000; // dist where lines start fading out (moving away from island)
export const islandAppearDist    = 4.7000; // dist where lines start appearing (approaching island)
